import styled from "styled-components"

const LoadMoreButton = styled.button`
  background: url(/assets/svg/show-more.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  cursor: pointer;
  font-weight: bold;
  padding: 16px 20px 16px 20px;
`

export default LoadMoreButton
